var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "container" }, [
        _c("h1", [_vm._v("Kariéra")]),
        _vm._v(" "),
        _c("div", { staticClass: "sluzby-wrapper" }, [
          _c(
            "ul",
            { staticClass: "sluzby-list" },
            _vm._l(_vm.poziceArr, function(pozice) {
              return _c(
                "li",
                {
                  key: pozice.id,
                  class: pozice.disabled ? "disabled" : "",
                  on: {
                    click: function($event) {
                      pozice.disabled ? false : _vm.openSidePage(pozice.id)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "sluzby-list-item" }, [
                    _c("span", { staticClass: "sluzby-list-title" }, [
                      _vm._v(_vm._s(pozice.name))
                    ]),
                    _vm._v(" "),
                    pozice.disabled
                      ? _c(
                          "span",
                          { staticClass: "tag-pripravujeme-container" },
                          [
                            _c("span", { staticClass: "tag-pripravujeme" }, [
                              _vm._v("Připravujeme")
                            ])
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              )
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "SidePage",
        { ref: "sidePageComponent" },
        [
          _vm.aktivniPoziceId === 1 ? _c("Programator") : _vm._e(),
          _vm._v(" "),
          _vm.aktivniPoziceId === 2 ? _c("SocialMediaSpecialist") : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("Footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }